import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Badge,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import Cart from './Cart';

const Navbar = () => {
  const { totalItems } = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();

  return (
    <>
      <AppBar 
        position="static" 
        elevation={1}
        sx={{
          backgroundColor: '#fff',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
        }}
      >
        <Toolbar sx={{ py: 1 }}>
          <Box 
            component={Link} 
            to="/"
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              textDecoration: 'none',
              color: 'inherit',
              flexGrow: 1,
            }}
          >
            <img
              src="/logo2.jpg"
              alt="Knack Shop"
              style={{
                height: isMobile ? '50px' : '65px',
                marginRight: theme.spacing(2),
                objectFit: 'contain',
              }}
            />
            {!isMobile && (
              <Typography
                variant="h6"
                sx={{
                  fontFamily: '"Poppins", sans-serif',
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                }}
              >
                The Knack Shop
              </Typography>
            )}
          </Box>
          
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Button
              component={Link}
              to="/"
              sx={{
                color: location.pathname === '/' ? theme.palette.primary.main : theme.palette.text.primary,
                fontWeight: location.pathname === '/' ? 600 : 500,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Home
            </Button>
            <Button
              component={Link}
              to="/products"
              sx={{
                color: location.pathname === '/products' ? theme.palette.primary.main : theme.palette.text.primary,
                fontWeight: location.pathname === '/products' ? 600 : 500,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Products
            </Button>
            <Button
              component={Link}
              to="/faq"
              sx={{
                color: location.pathname === '/faq' ? theme.palette.primary.main : theme.palette.text.primary,
                fontWeight: location.pathname === '/faq' ? 600 : 500,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              FAQ
            </Button>
            <IconButton 
              onClick={() => setCartOpen(true)}
              sx={{ 
                ml: 2,
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <Badge 
                badgeContent={totalItems} 
                color="primary"
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: theme.palette.primary.main,
                    color: '#fff',
                  },
                }}
              >
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Cart open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
};

export default Navbar;
